import { useEffect, useState } from "react";

interface SessionWarningEvent extends CustomEvent {
  detail: {
    message: string;
  };
}

export function useSessionWarning() {
  const [warning, setWarning] = useState<string | null>(null);

  useEffect(() => {
    const handleSessionWarning = (event: SessionWarningEvent) => {
      setWarning(event.detail.message);

      // Auto-clear warning after 10 seconds unless it's a critical timeout message
      if (!event.detail.message.includes("will expire")) {
        setTimeout(() => {
          setWarning(null);
        }, 10000);
      }
    };

    const handleClearWarning = () => {
      setWarning(null);
    };

    window.addEventListener(
      "sessionWarning",
      handleSessionWarning as EventListener
    );
    window.addEventListener("clearSessionWarning", handleClearWarning);

    return () => {
      window.removeEventListener(
        "sessionWarning",
        handleSessionWarning as EventListener
      );
      window.removeEventListener("clearSessionWarning", handleClearWarning);
    };
  }, []);

  const clearWarning = () => {
    setWarning(null);
    window.dispatchEvent(new CustomEvent("clearSessionWarning"));
  };

  return { warning, clearWarning };
}
